import React from "react";
import "../../styles/shared/loading.css" 

export default function Loading() {
  return (
    <div className="loading-wrapper" role="status" aria-label="Yüklənir">
      <div className="loading-spinner" />
    </div>
  );
}
